import { Theme } from '@mui/material';

export const getWrapperStyles = () => ({
	display: 'flex',
	width: { xs: '100%', md: '100%' },
	flex: '1 1 auto',
	flexDirection: { xs: 'column', md: 'row' },
	justifyContent: 'space-between',
	gap: { xs: '2rem' }, // Increased spacing between tabs (sm:6, md:8)
	mb: { xs: 4, md: '40px' },
});

export const getNavLinkStyles = (theme: Theme) => ({
	justifyContent: 'flex-start',
	lineHeight: '1.5rem',
	[theme.breakpoints.down('lg')]: {
		fontSize: '0.8rem',
	},
});

export const getNavTitleStyles = () => ({
	letterSpacing: '0.188rem',
	fontSize: { xs: '1.5rem', md: '.73vw' },
	fontWeight: { xs: 350, md: 700 },
	fontFamily: 'Messina Sans',
});

export const footerLinkTextBoxDesktopStyles = (isOneTrustLink: boolean) => ({
	display: 'flex',
	flexWrap: 'nowrap',
	justifyContent: 'flex-start',
	alignItems: 'center',
	...(isOneTrustLink && { whiteSpace: 'nowrap' }),
});
